var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIntegrationIcon05(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-54.9%",
    y: "-65.8%",
    width: "209.9%",
    height: "231.5%",
    filterUnits: "objectBoundingBox",
    id: "b"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    x: "-44.8%",
    y: "-123.1%",
    width: "189.7%",
    height: "346.1%",
    filterUnits: "objectBoundingBox",
    id: "d"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    x: "-74.1%",
    y: "-42.9%",
    width: "248.3%",
    height: "185.7%",
    filterUnits: "objectBoundingBox",
    id: "f"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    x: "-44.8%",
    y: "-42.9%",
    width: "189.7%",
    height: "185.7%",
    filterUnits: "objectBoundingBox",
    id: "g"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "-21.618%",
    x2: "100%",
    y2: "121.618%",
    id: "a"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6C338",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD351",
    offset: "52.3%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6C338",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "100%",
    y1: "-326.611%",
    x2: "0%",
    y2: "426.611%",
    id: "c"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#286EE6",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4286FB",
    offset: "52.1%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#286EE6",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "95.742%",
    y1: "0%",
    x2: "8.1%",
    y2: "100%",
    id: "e"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#069B5A",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#11AA62",
    offset: "53.1%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#069B5A",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.64
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    filter: "url(#b)",
    d: "M10.535 0H21.79l10.586 18.249H21.095z",
    transform: "translate(8 10)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    filter: "url(#d)",
    d: "M32.376 18.249 26.735 28H5.615l5.653-9.751z",
    transform: "translate(8 10)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#e)",
    filter: "url(#f)",
    d: "M5.615 28 0 18.249 10.535 0l5.653 9.776z",
    transform: "translate(8 10)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m5.615 28 10.51-9.75h-4.857L5.615 28Zm26.76-9.75H21.108l-2.478-4.275 13.747 4.274ZM10.536 0l3.25 13.911 2.403-4.135L10.535 0Z",
    fill: "#000",
    opacity: 0.1,
    filter: "url(#g)",
    transform: "translate(8 10)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M10.535 0H21.79l10.586 18.249H21.095z",
    transform: "translate(8 10)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    d: "M32.376 18.249 26.735 28H5.615l5.653-9.751z",
    transform: "translate(8 10)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#e)",
    d: "M5.615 28 0 18.249 10.535 0l5.653 9.776z",
    transform: "translate(8 10)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13.615 38 10.51-9.75h-4.857L13.615 38Zm26.76-9.75H29.108l-2.478-4.275 13.747 4.274ZM18.536 10l3.25 13.911 2.403-4.135L18.535 10Z",
    fill: "#000",
    opacity: 0.1
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntegrationIcon05);
export default __webpack_public_path__ + "static/media/integration-icon-05.b1e93efe9cd0f81312117d4d699a6a2c.svg";
export { ForwardRef as ReactComponent };